import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneonedaytourcab() {



  const cardData = {
"keyword": "Pune One Day Tour Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune One Day Tour Cab for tourists, families, and business travelers who want to explore the best attractions of Pune in a single day. Whether you are planning a short sightseeing trip, temple tour, historical exploration, cultural visit, shopping trip, or leisure outing, our cab service ensures a smooth and well-organized travel experience. With experienced drivers who are familiar with Pune city routes and traffic conditions, clean air-conditioned vehicles maintained for comfort, and transparent pricing with no hidden charges, we provide a dependable travel experience throughout the day. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible hourly and full-day packages, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and memorable one-day Pune sightseeing experience.",

"topPlaces": [
  
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description":
      "Dagdusheth Halwai Ganpati Temple is one of Pune’s most popular temples dedicated to Lord Ganesha, attracting thousands of devotees daily for darshan and blessings."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a scenic hill fort near Pune known for trekking, panoramic views, and strong Maratha historical importance, making it ideal for adventure and nature lovers."
  },
  {
    "title": "Parvati Hill Temple",
    "description":
      "Parvati Hill Temple is a peaceful hilltop destination offering panoramic views of Pune city and a calm spiritual atmosphere ideal for morning or evening visits."
  },
  {
    "title": "Shaniwar Wada",
    "description":
      "Shaniwar Wada is a historic fort palace in Pune built by the Peshwas, known for its grand architecture, Maratha heritage, and historical significance. It is a must-visit attraction in any Pune one-day tour itinerary."
  },
  {
    "title": "Aga Khan Palace",
    "description":
      "Aga Khan Palace is a famous monument associated with Mahatma Gandhi and India’s freedom struggle. It features peaceful gardens, museum exhibits, and historical architecture."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description":
      "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, sculptures, musical instruments, and cultural heritage items, making it a key cultural stop."
  },
  {
    "title": "Osho International Meditation Resort",
    "description":
      "Osho Ashram in Koregaon Park is a globally recognized meditation center known for its peaceful environment, wellness programs, and spiritual experiences."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description":
      "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, known for its unique architecture and historical importance in Pune city."
  },
  {
    "title": "Koregaon Park",
    "description":
      "Koregaon Park is a lively area known for cafes, restaurants, shopping outlets, and nightlife, making it a popular stop during city tours."
  },
  {
    "title": "Pune One Day Scenic Route",
    "description":
      "The Pune One Day Tour Cab covers a mix of historical monuments, spiritual temples, cultural museums, modern attractions, and scenic city roads, offering a complete and comfortable sightseeing experience in a single day."
  }
],



services: [
  {
    name: "Pune One Day Tour Cab",
    description: "Pune one day tour cab service provides reliable transportation for passengers planning sightseeing and local travel across Pune within a single day. Comfortable vehicles with experienced drivers ensure smooth city travel for families, tourists, and local travelers. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different sightseeing requirements. Flexible booking options allow convenient one-day tour cab reservations."
  },
  {
    name: "Pune One Day Taxi Service",
    description: "Pune one day taxi service offers dependable transportation for sightseeing tours and city travel across Pune with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth local travel suitable for tourism, heritage visits, shopping, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the city tour. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient one-day taxi reservations."
  },
  {
    name: "Pune Day Trip Cab",
    description: "Pune day trip cab service provides comfortable transportation for passengers visiting tourist attractions, temples, forts, museums, and nearby sightseeing places around Pune. Vehicles ensure reliable local travel with experienced chauffeurs offering safe and smooth city journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for one-day sightseeing and tourism requirements. Flexible booking options allow convenient day trip cab reservations."
  },
  {
    name: "Pune Full Day Cab Pune",
    description: "Pune full day cab Pune service offers reliable transportation with comfortable vehicles and professional drivers for full-day travel across Pune city and nearby attractions. Vehicles provide smooth city travel suitable for tourism, sightseeing, shopping trips, and family outings. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy full-day cab reservations."
  },
  {
    name: "Pune Sightseeing One Day Cab",
    description: "Pune sightseeing one day cab service provides dependable transportation solutions for passengers traveling across Pune for sightseeing and local tourism. Vehicles are suitable for city travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for tourism, heritage visits, and local sightseeing tours. Flexible booking options allow convenient sightseeing cab reservations."
  },
  {
    name: "Pune Tourist One Day Taxi",
    description: "Pune tourist one day taxi service provides transparent and reliable transportation for travelers visiting Pune’s famous tourist attractions and cultural landmarks. Travelers can enjoy comfortable journeys with experienced drivers familiar with local sightseeing routes and destinations. Comfortable vehicles ensure smooth city travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient tourist taxi reservations."
  },
  {
    name: "Pune Local One Day Tour",
    description: "Pune local one day tour service provides economical and comfortable transportation for travelers planning sightseeing tours across Pune city in a single day. Comfortable vehicles ensure smooth city travel suitable for tourism, shopping, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient local one-day tour reservations."
  },
  {
    name: "Best Pune One Day Cab",
    description: "Best Pune one day cab service offers convenient transportation for passengers planning one-day sightseeing and travel trips across Pune city. Comfortable vehicles provide smooth local travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for local sightseeing, shopping, and tourism visits. Flexible booking options allow convenient one-day cab reservations."
  },
  {
    name: "Cheap Pune One Day Taxi",
    description: "Cheap Pune one day taxi service allows passengers to reserve comfortable transportation for exploring multiple attractions and tourist places across Pune within a budget. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the city tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow affordable one-day taxi reservations."
  },
  {
    name: "SUV Pune One Day Tour Cab",
    description: "SUV Pune one day tour cab service provides spacious transportation for families and groups traveling across Pune for sightseeing and tourism. SUV vehicles offer comfortable seating, luggage capacity, and smooth city performance suitable for family outings and local tours. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV tour cab reservations."
  },
  {
    name: "Innova Pune One Day Cab",
    description: "Innova Pune one day cab service provides premium SUV transportation for passengers seeking comfortable and reliable city sightseeing travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Sedan Pune One Day Taxi",
    description: "Sedan Pune one day taxi service offers economical and comfortable transportation for solo travelers, couples, and small families exploring Pune city. Sedan vehicles provide smooth city travel with comfortable seating and luggage space suitable for local sightseeing journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient sedan taxi reservations."
  },
  {
    name: "Pune Custom Day Tour Cab",
    description: "Pune custom day tour cab service offers dependable transportation for passengers planning personalized sightseeing routes and travel itineraries across Pune. Comfortable vehicles ensure smooth city travel suitable for tourism, educational tours, shopping trips, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow customized day tour cab reservations."
  },
  {
    name: "Pune Private One Day Cab",
    description: "Pune private one day cab service provides exclusive transportation for passengers looking for private city travel and sightseeing experiences in Pune. Comfortable vehicles ensure smooth and secure travel suitable for tourists, families, couples, and corporate travelers. Professional drivers ensure punctual pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient private one-day cab reservations."
  },
  {
    name: "Pune Travel Day Cab",
    description: "Pune travel day cab service provides reliable transportation for passengers planning local travel, sightseeing tours, shopping trips, and city exploration across Pune in a single day. Comfortable vehicles ensure smooth and safe city travel suitable for tourists, families, and business travelers. Professional chauffeurs ensure timely pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient travel day cab reservations."
  }
],

tableData: [
  ["Pune One Day Tour Cab", "Pune One Day Taxi Service"],
  ["Pune Day Trip Cab", "Pune Full Day Cab Pune"],
  ["Pune Sightseeing One Day Cab", "Pune Tourist One Day Taxi"],
  ["Pune Local One Day Tour", "Best Pune One Day Cab"],
  ["Cheap Pune One Day Taxi", "SUV Pune One Day Tour Cab"],
  ["Innova Pune One Day Cab", "Sedan Pune One Day Taxi"],
  ["Pune Custom Day Tour Cab", "Pune Private One Day Cab"],
  ["Pune Travel Day Cab", "Pune One Day Tour Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune One Day Tour Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune One Day Tour cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and enjoyable sightseeing travel."
      },
      {
        WhyChooseheading: "Affordable One Day Tour Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune One Day Tour cab pricing with transparent fare details and no hidden charges. Customers receive complete tour package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 One Day Tour Cab Availability",
        WhyChoosedescription: "Our Pune One Day Tour cab service operates 24 hours a day for sightseeing tours, family outings, tourist visits, temple tours, and customized travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences during one day tours."
      },
      {
        WhyChooseheading: "Customized One Day Tour Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Pune city tours, nearby hill stations, temple tours, forts, beaches, and customized one day travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Tourist Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune sightseeing destinations and nearby tourist attractions, ensuring smooth travel and proper route planning for one day tours."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune One Day Tour cab service?", answer: "Pune One Day Tour cab service provides comfortable taxi transportation for sightseeing tours, nearby destinations, temples, forts, and tourist attractions." },
    { question: "Is Pune One Day Tour cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune One Day Tour cab service." },
    { question: "Which vehicles are available for Pune One Day Tour travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book customized one day tour packages?", answer: "Yes, customers can book customized one day sightseeing and travel packages according to their requirements." },
    { question: "Which destinations are covered in Pune One Day Tours?", answer: "Shivai Travels covers destinations like Lonavala, Mahabaleshwar, Sinhagad Fort, Lavasa, temples, beaches, and Pune city attractions." },
    { question: "Are all Pune One Day Tour taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune One Day Tour cab service online?", answer: "Yes, customers can easily book Pune One Day Tour cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune One Day Tour cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune One Day Tour cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rahul Patil",
      feedback:
        "Booked Pune One Day Tour cab service with Shivai Travels. Comfortable vehicle, smooth sightseeing experience, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Deshpande",
      feedback:
        "Excellent Pune One Day Tour taxi service. Affordable pricing, clean cab, and wonderful family travel experience.",
      rating: 5
    }
  ];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune One Day Tour Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-one-day-tour-cab.jpg",
  "description": "Book Pune One Day Tour cab service for comfortable full-day sightseeing and local travel. Shivai Travels offers customized one-day tour packages with sedan, SUV, Innova, and luxury cab options available 24x7 for Pune tourist spots, heritage sites, and temple visits.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹9/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-one-day-tour-cab"
  }
};







  return (
    <div>



<Helmet>
  <title>Pune One Day Tour Cab | Full Day Sightseeing Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune One Day Tour cab service for full-day sightseeing and travel. Affordable packages with sedan, SUV, Innova, and luxury cabs available 24x7 for Pune tourist attractions, temples, and local exploration."
  />

  <meta
    name="keywords"
    content="pune one day tour cab, pune one day taxi service, pune day trip cab, pune full day cab pune, pune sightseeing one day cab, pune tourist one day taxi, pune local one day tour, best pune one day cab, cheap pune one day taxi, suv pune one day tour cab, innova pune one day cab, sedan pune one day taxi, pune custom day tour cab, pune private one day cab, pune travel day cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneonedaytourcab;